var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"share__icon",on:{"click":_vm.favoriteContent}},[(_vm.favorited)?_c('i',{staticClass:"fas fa-bookmark"}):_c('i',{staticClass:"far fa-bookmark"})]),_vm._v(" "),_c('modal-login',{ref:"modal"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }